<script>
import eventBus from '@utils/eventBus'

import StarsRating from '@components/stars-rating.vue'

import Resizable from '@src/mixins/resizable.js'
import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    StarsRating
  },
  mixins: [
    Resizable,
    Translatable
  ],
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    reviewCardTruncationLimit() {
      return this.desktopScreen ? 180 : 210
    }
  },
  data() {
    return {
      translationActive: false,
      reviewExpanded: false,
    }
  },
  methods: {
    expand() {
      eventBus.$emit('collapseSlider')
      this.reviewExpanded = true

      // We need to synchronize the slides height
      this.$nextTick(() => {
        const bodyHeight = this.$refs.body.offsetHeight
        const reviews = document.querySelectorAll('.review-slide')
        reviews.forEach((el) => {
          el.querySelector('.review-body').style.height = `${bodyHeight}px`
        })
      })
    },
    collapse() {
      eventBus.$emit('collapseSlider')
    }
  },
  created() {
    eventBus.$on('collapseSlider', () => {
      this.reviewExpanded = false
      this.$nextTick(() => {
        const reviews = document.querySelectorAll('.review-slide')
        reviews.forEach(el => {
          el.querySelector('.review-body').style.removeProperty('height')
        })
      })
    })
  }
}
</script>

<template>
  <div class="review-slide" ref="sliderContainer">
    <div class="review-header">
      <StarsRating class="rating" :rating="review.rating"/>
      <div class="review-summary">
        {{ review.title }}
      </div>
      <div class="date">
        {{ review.date | monthDDYY }}
      </div>
    </div>
    <div class="review-body" ref="body">
      <span v-if="!reviewExpanded" class="review-text" :inner-html.prop="review.text | truncate(reviewCardTruncationLimit)">
      </span>
      <span v-else class="review-text" v-html="review.text">
      </span>
      <span
        v-if="review.text.length > reviewCardTruncationLimit && !reviewExpanded"
        class="more-btn"
        @click="expand"
      >
        {{ getTranslatedContent('REVIEWS_more') }}
      </span>
      <span
          v-else-if="review.text.length > reviewCardTruncationLimit && reviewExpanded"
          class="more-btn"
          @click="collapse"
      >
        {{ getTranslatedContent('REVIEWS_less') }}
      </span>
    </div>
    <div class="review-footer">
      <div class="reviewer-data">
        {{ `${review.name}` + `${review.place ? ', ' + review.place  : ''}` }}
      </div>
      <div class="see-translation">
        <!-- {{  translationActive ? 'See Original' : 'See Translation' }} -->
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

.swiper-slide {
  height: auto;
}

.review-slide {
  display: flex;
  flex-direction: column;
  width: 367px;
  min-height: 255px;
  height: 100%;
  background: $light-gray;
}

.review-header {
  margin-left: 32px;
  padding-top: 15px;
  height: auto;
  display: flex;
  flex-direction: column;
}

.reviews-pagination {
  display: none !important;
}

.rating {
  margin-left: -3px;
}

.review-summary {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  margin-top: 12px;
  color: $dark-blue;
}

.date {
  font-family: "Open Sans Semibold", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: $dark-blue;
  opacity: 0.9;

  margin-top: 10px;
}

.review-body {
  flex-grow: 1;
  width: 318px;
  min-height: 80px;
  height: auto;
  margin-left: 32px;
  margin-top: 11px;
}

.review-text {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: $black;
  // opacity: 0.8;
  word-wrap: break-word;
}

.review-footer {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding-top: 27px;
  margin-right: 15px;
  margin-left: 32px;
  padding-bottom: 21px;
}

.more-btn {
  cursor: pointer;
  font-family: "Open Sans Semibold", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: $dark-blue;
}

.reviewer-data {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: $dark-blue;
  opacity: 0.6;
  max-width: 200px;
}

.see-translation {
  cursor: pointer;
  min-width: 90px;
  margin-left: auto;
  font-family: Open Sans Semibold, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: $dark-blue;
}

.see-translation:hover {
  color: $orange;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .review-slide {
    width: 100%;
    min-height: 270px;
    height: 100%;
  }

  .review-body {
    width: auto;
  }

  .review-body,
  .review-footer,
  .review-header {
    margin-left: 13px;
    margin-right: 13px;
  }

  .review-footer {
    padding-top: 27px;
    padding-bottom: 16px;
    margin-right: 16px;
  }

  .reviewer-data {
    max-width: 195px;
  }

  .rating {
    margin-left: -3px;
  }

  .reviews-pagination {
    margin-top: 15px;
    display: flex !important;
  }
}
</style>
